import { createContext } from "react";
const OurTeamContext = createContext({});
export default OurTeamContext;
